<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Ratings</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (unitTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Unit Type:</span>
            <select
              class="halfWidthInputField"
              #unitTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitTypeSelection.Name)"
              (change)="unitChanged(unitTypeSelection, unitTypeInput.value)"
              [value]="unitTypeSelection.Value.toString()">
              @for (allowable of unitTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="unitTypeSelection.Value && unitTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (unitSizeSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Size:</span>
            <select
              class="halfWidthInputField"
              #unitSizeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitSizeSelection.Name)"
              (change)="selectionChanged(unitSizeSelection, unitSizeInput.value)"
              [value]="unitSizeSelection.Value.toString()">
              @for (allowable of unitSizeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="unitSizeSelection.Value && unitSizeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (systemTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">System Type:</span>
            <select
              class="halfWidthInputField"
              #systemTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(systemTypeSelection.Name)"
              (change)="systemChanged(systemTypeSelection, systemTypeInput.value)"
              [value]="systemTypeSelection.Value.toString()">
              @for (allowable of systemTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="systemTypeSelection.Value && systemTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (coilRowsSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Coil Rows:</span>
            <select
              class="halfWidthInputField"
              #coilRowsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(coilRowsSelection.Name)"
              (change)="selectionChanged(coilRowsSelection, coilRowsInput.value)"
              [value]="coilRowsSelection.Value.toString()">
              @for (allowable of coilRowsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="coilRowsSelection.Value && coilRowsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (unitVoltageSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Unit Voltage:</span>
            <select
              class="halfWidthInputField"
              #unitVoltageInput
              [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
              (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
              [value]="unitVoltageSelection.Value.toString()">
              @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (tubeWallThicknessSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Tube Wall Thickness:</span>
            <select
              class="halfWidthInputField"
              #tubeWallThicknessInput
              [class.invalidConfigurationSelection]="isInvalidSelection(tubeWallThicknessSelection.Name)"
              (change)="selectionChanged(tubeWallThicknessSelection, tubeWallThicknessInput.value)"
              [value]="tubeWallThicknessSelection.Value.toString()">
              @for (allowable of tubeWallThicknessSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="tubeWallThicknessSelection.Value && tubeWallThicknessSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (electricHeatSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Electric Heat KW:</span>
            <select
              class="halfWidthInputField"
              #electricHeatInput
              [class.invalidConfigurationSelection]="isInvalidSelection(electricHeatSelection.Name)"
              (change)="selectionChanged(electricHeatSelection, electricHeatInput.value)"
              [value]="electricHeatSelection.Value.toString()">
              @for (allowable of electricHeatSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="electricHeatSelection.Value && electricHeatSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (primaryCoilCircuitSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Primary Coil Circuit:</span>
            <select
              class="halfWidthInputField"
              #primaryCoilCircuitInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryCoilCircuitSelection.Name)"
              (change)="selectionChanged(primaryCoilCircuitSelection, primaryCoilCircuitInput.value)"
              [value]="primaryCoilCircuitSelection.Value.toString()">
              @for (allowable of primaryCoilCircuitSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="primaryCoilCircuitSelection.Value && primaryCoilCircuitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (controlTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Control Type:</span>
            <select
              class="halfWidthInputField"
              #controlTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(controlTypeSelection.Name)"
              (change)="selectionChanged(controlTypeSelection, controlTypeInput.value)"
              [value]="controlTypeSelection.Value.toString()">
              @for (allowable of controlTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="controlTypeSelection.Value && controlTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (motorTypeSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Motor Type:</span>
            <select
              class="halfWidthInputField"
              #motorTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(motorTypeSelection.Name)"
              (change)="selectionChanged(motorTypeSelection, motorTypeInput.value)"
              [value]="motorTypeSelection.Value.toString()">
              @for (allowable of motorTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="motorTypeSelection.Value && motorTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
        @if (secondaryCoilCircuitSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Secondary Coil Circuit:</span>
            <select
              class="halfWidthInputField"
              #secondaryCoilCircuitInput
              [class.invalidConfigurationSelection]="isInvalidSelection(secondaryCoilCircuitSelection.Name)"
              (change)="selectionChanged(secondaryCoilCircuitSelection, secondaryCoilCircuitInput.value)"
              [value]="secondaryCoilCircuitSelection.Value.toString()">
              @for (allowable of secondaryCoilCircuitSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="secondaryCoilCircuitSelection.Value && secondaryCoilCircuitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      @if (finDensitySelection) {
        <div class="configurationDetailRow">
          <span class="halfWidthConfigurationInput"></span>
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Fin Density:</span>
            <select
              class="halfWidthInputField"
              #finDensityInput
              [class.invalidConfigurationSelection]="isInvalidSelection(finDensitySelection.Name)"
              (change)="selectionChanged(finDensitySelection, finDensityInput.value)"
              [value]="finDensitySelection.Value.toString()">
              @for (allowable of finDensitySelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="finDensitySelection.Value && finDensitySelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        </div>
      }
    </div>
  }
  @if (showCoilWarningMessage()) {
    <div class="message-holder">
      <span class="coil-warning">Note: For non-standard coil circuit options, contact your Application Engineer for Coil Connection details</span>
    </div>
  }
</div>
